
const { verbs, nons, endings } = require("./data");

export const makeIdea = function () {
    let v1 = Math.floor(Math.random() * verbs.length);
    let v2 = Math.floor(Math.random() * nons.length);
    let v3 = Math.floor(Math.random() * endings.length);

    return `${verbs[v1]} ${nons[v2]} ${endings[v3]}`;
};